import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { CircularProgress, Theme, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid/Grid';
import Paper from '@mui/material/Paper/Paper';
import { Box } from '@mui/system';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { IProjectLearningReportArg } from '../../../../service/report/interface/IProjectLearningReportArg';
import { IMetricsDomain } from './store/IMetricsDomain';
import { MetricsSectionUI } from './store/MetricsSectionUI';
import { Colors } from '../../../design/color/Colors';

type IMetricsSectionProperties = {
  metricsDomain: IMetricsDomain;
  reportArg?: IProjectLearningReportArg;
  averageProgressLabelKey?: string;
};

export const MetricsSection = observer(({ metricsDomain, reportArg = {}, averageProgressLabelKey }: IMetricsSectionProperties) => {
  const classes = useStyles();
  const [{ data, isFetching, boot }] = useState(() => new MetricsSectionUI(metricsDomain, reportArg, undefined, averageProgressLabelKey));

  useEffect(() => {
    boot();
  }, []);

  if (isFetching.value && !data.list.length) {
    return (
      <Box sx={{ minHeight: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {data.list.map((m, i) => (
        <Grid item key={i} xs={12} sm={6} md={4}>
          <Paper
            className={classes.itemContainer}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography variant="caption" color="text.secondary">
                {m.label}
              </Typography>
              {m.infoTooltip ? (
                <Tooltip title={m.infoTooltip}>
                  <InfoOutlinedIcon sx={{ color: Colors.textSecondary, fontSize: '16px' }} />
                </Tooltip>
              ) : null}
            </Box>
            {m.maxValue !== undefined ? (
              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mt: 0.5 }}>
                <Typography variant="h4" color="text.primary">
                  {m.value}
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400 }}>
                  / {m.maxValue}
                </Typography>
              </Box>
            ) : (
              <Typography variant="h4" color="text.primary" sx={{ mt: 0.5 }}>
                {m.value}
              </Typography>
            )}
            <Typography variant="caption" color="text.secondary">
              {m.sub}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  itemContainer: {
    padding: theme.spacing(2),
    backgroundColor: Colors.bgSurface,
  },
}));
